import React from 'react';
import "./Modal.css";

const Modal = ({button, visible, children}) => {

    return(
        <div className="modal column nowrap ">
            <div className="buttonModal row nowrap">
                {button}
            </div>
            {(visible)?
                <div className="contentModal column nowrap centerContent centerItens">{children}</div>:
                    <div style={{display:"none"}}></div>}
        </div>
    );
};

export default Modal;